<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";

    export let serviceId = null;
    export let notificationType = null;
    export let closeCallback;

    let notification = null;
    let isModified = false;
    let testNotification = false;
    let testEmail = '';


    const load = () => {
        const onSuccess = result => {
            notification = result;
            notification.type = ~~notification.type;
        }

        const onFailure = err => {
        };

        R.handle(R.ws_service.notificationDetails, {
            ws_service_id: serviceId,
            type: notificationType.type
        }, onSuccess, onFailure, LOADER.POPUP);
    }


    const save = () => {

        const onSuccess = result => {
            notification.id = result.id;
            isModified = true;
            Notifier.showMessage("Η ενημέρωση πραγματοποιήθηκε");
        }

        const onFailure = err => {
        };


        notification.subject = notification.subject.trim();
        if (!notification.subject) {
            Notifier.showError("Δεν έχετε πληκτρολογήσει το θέμα της ειδοποίησης!");
            setFocusTo('subject');
            return;
        }

        notification.message = notification.message.trim();
        if (!notification.message) {
            Notifier.showError("Δεν έχετε πληκτρολογήσει το μήνυμα της ειδοποίησης!");
            setFocusTo('message');
            return;
        }

        if (notification.type < 2 && !notification.days_before) {
            Notifier.showError("Δεν έχετε ορίσει τις μέρες που θα σταλεί η ειδοποίηση πριν την λήξη συνδρομής!");
            setFocusTo('daysBefore');
            return;
        }

        if (notification.type == 2) {
            notification.days_before = 0;
        }

        notification.ws_service_id = serviceId;

        R.handle(R.ws_service.notificationEdit, notification, onSuccess, onFailure, LOADER.POPUP);
    }


    const insertAtCaret = (text) => {
        const textarea = document.getElementById('message');
        textarea.setRangeText(
            text,
            textarea.selectionStart,
            textarea.selectionEnd,
            'end'
        );
        notification.message = textarea.value;
    }

    const close = () => {
        closeCallback(isModified ? notification : null);
        notification = null;
    }

    const openTest = () => {
        testNotification = true;
        setFocusTo('textEmail');
    }

    const sendTest = () => {

    }

    const closeTest = () => {
        testNotification = false;
    }

    load();
</script>

{#if notification}
    <Modal title="Ειδοποίηση Υπηρεσίας" icon="mail" modalMd closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            <h5 class="mb-4">{ notificationType.name }</h5>
            <div class="row">
                <div class="col-xl-8">
                    <div class="form-group">
                        <label>Θέμα ειδοποίησης</label>
                        <input type="text" class="form-control" id="subject" bind:value="{ notification.subject }"/>
                    </div>
                    <div class="form-group">
                        <label>Κείμενο</label>
                        <div class="message-box">
                            {#if !notification.message}
                                <div class="message-placeholder" on:click={ () => setFocusTo('message', 10) }>
                                    κείμενο μηνύματος<br>
                                    χρησιμοποιήστε τα "Key Codes" για να συμπληρωθεί αυτόματα το όνομα υπηρεσίας,
                                    ημερομηνία λήξης, έναρξης κ.λ.π.<br>
                                    π.χ. η συνδρομή σας στο [SERVICE-NAME] πρόκειται να λήξει στις [EXPIRE-DATE] ...
                                </div>
                            {/if}
                            <textarea class="form-control" id="message" style="min-height: 130px;"
                                      bind:value="{ notification.message }"></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4">
                    <table class="table">
                        <tr>
                            <td>Ημερομηνία έναρξης</td>
                            <td style="width: 130px;">
                                <button class="btn-reset is-link" on:click={ () => insertAtCaret(' [START-DATE] ') }>
                                    [START-DATE]
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>Ημερομηνία λήξης</td>
                            <td>
                                <button class="btn-reset is-link" on:click={ () => insertAtCaret(' [EXPIRE-DATE] ') }>
                                    [EXPIRE-DATE]
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>Όνομα υπηρεσίας</td>
                            <td>
                                <button class="btn-reset is-link" on:click={ () => insertAtCaret(' [SERVICE-NAME] ') }>
                                    [SERVICE-NAME]
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>Τιμή υπηρεσίας</td>
                            <td>
                                <button class="btn-reset is-link" on:click={ () => insertAtCaret(' [SERVICE-PRICE] ') }>
                                    [SERVICE-PRICE]
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>Όνομα πελάτη</td>
                            <td>
                                <button class="btn-reset is-link" on:click={ () => insertAtCaret('  [CLIENT-NAME] ') }>
                                    [CLIENT-NAME]
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            {#if notification.type < 2}
                <div class="form-group">
                    <label>Αποστολή πριν την λήξη (ημέρες)</label>
                    <input type="number" id="daysBefore" class="form-control" max="60"
                           bind:value="{ notification.days_before }">
                </div>
            {/if}
            <div class="form-group">
                <Checkbox label="Ενεργή ειδοποίηση" bind:checked={ notification.is_active }/>
            </div>
            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary" on:click={ openTest }>Test</button>
                <button class="btn btn-primary" on:click={ save }>Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}


{#if testNotification}
    <Modal title="Test Ειδοποίησης" icon="mail" closeOnEscape="{ true }" on:close="{ closeTest }">
        <div slot="body">
            <h5 class="mb-4">Test Ειδοποίησης</h5>
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" id="testEmail" bind:value="{ testEmail }"/>
            </div>
            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => closeTest() }">Κλείσιμο</div>
                <button class="btn btn-primary" on:click={ sendTest }>Αποστολή</button>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .message-box {
        position: relative;
        height: max-content;
    }

    .message-box .message-placeholder {
        position: absolute;
        padding: 10px 10px 0 14px;
        color: #ccc;
        width: 100%;
        height: calc(100% - 10px);
        overflow: hidden;
    }
</style>